
import { defineComponent, PropType } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { ResponseSettingItem } from '@/repositories/keiei-joho/data'
import { TaishakuTaishoUiItem } from '@/views/keiei-joho/data'

export default defineComponent({
  components: {
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<TaishakuTaishoUiItem>,
      required: true
    }
  },
  emits: {
    changeInput: (item: TaishakuTaishoUiItem) => true
  },
  setup (props, { emit }) {
    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem: TaishakuTaishoUiItem = props.item
      switch (panelName) {
        case 'kasan':
          propItem.item.positiveKmkSettings = item
          break
        case 'gensan':
          propItem.item.negativeKmkSettings = item
          break
      }
      emit('changeInput', propItem)
    }

    return {
      onUpdateKmk
    }
  }
})
